<!-- Divider -->
<div
  class="fuse-vertical-navigation-item-wrapper divider"
  [ngClass]="$safeNavigationMigration(item.classes?.wrapper)"
></div>
